import React, { Component } from 'react';
import PropTypes from 'prop-types';

import TableSelector from 'components/ui/form/dates/lib/TableSelector';

const DEFAULT_MIN_YEAR = 20;

/** Component to select a year in a table */
class YearSelector extends Component {

    static DEFAULT_MIN_YEAR = DEFAULT_MIN_YEAR;
    static propTypes = {
        minYear:      PropTypes.number, // The min available year to select
        maxYear:      PropTypes.number, // The max available year to select
        defaultValue: PropTypes.number, // The default selected month
        onChange:     PropTypes.func, // Listener for when the selected month changes
        onClickTitle: PropTypes.func // Listener for when the title has been clicked
    };
    static defaultProps = {
        minYear: (new Date()).getFullYear() - DEFAULT_MIN_YEAR,
        maxYear: (new Date()).getFullYear()
    };

    state = {
        defaultValue: undefined // The default year
    };

    /**
     * Init the state
     */
    componentWillMount() {
        const { defaultValue } = this.props;

        this.setState({
            defaultValue: typeof defaultValue === 'number' ? {
                id:   defaultValue,
                text: defaultValue
            } : defaultValue
        });
    }

    /**
     * Updates the state when the defaultValue has changed
     */
    componentWillReceiveProps(nextProps) {
        const { defaultValue } = this.props;

        (nextProps.defaultValue !== defaultValue) && this.setState({
            defaultValue: typeof nextProps.defaultValue === 'number' ? {
                id:   nextProps.defaultValue,
                text: nextProps.defaultValue
            } : nextProps.defaultValue
        });
    }

    /**
     * Creates the array that contains the year data objects
     * @returns {Array} The array with the years
     */
    getYears() {
        const
            { minYear, maxYear } = this.props,
            ret = [];

        for (let i = minYear; i <= maxYear; i++) {
            ret.push({
                id:   i,
                text: i
            });
        }

        return ret;
    }

    render() {
        const
            { onChange, onClickTitle } = this.props,
            { defaultValue } = this.state;

        return (
            <TableSelector
                items={this.getYears()}
                defaultValue={defaultValue}
                onChange={onChange}
                onClickTitle={onClickTitle}
            />
        );
    }
}


export default YearSelector;



// WEBPACK FOOTER //
// ./src/components/ui/form/dates/year/YearSelector.jsx